import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import ThemeModal from './ThemeModal';
import Modal from 'react-modal';
import Card from '../../../shared/Card';
import Icon from '../../../shared/Icon';
import Button from '../../../shared/buttons/Button';
import { snackBar } from 'highed';
import {
  postTeamChartmetaUsingTeamidAndChartid,
  postTeamChartDuplicateUsingTeamidAndChartid,
} from '../../../api/cloudApiGenerated';

class Theme extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.onClick = this.onClick.bind(this);
    this.onCloneTheme = this.onCloneTheme.bind(this);
    this.showModal = this.showModal.bind(this);

    this.onShowDeleteModal = this.onShowDeleteModal.bind(this);
    this.onCancel = this.onCancel.bind(this);

    this.state = {
      showDeleteModal: false,
    };

    this.themeModal = React.createRef();
  }

  showModal() {
    if (!this.props.hasPermission) this.props.showPaidPlanModal();
    else this.themeModal.current.openMetaDataModal();
  }

  onClick() {
    if (!this.props.hasPermission) this.props.showPaidPlanModal();
    else {
      postTeamChartmetaUsingTeamidAndChartid(this.props.team.id, this.props.theme.id, {
        deleted: !this.props.isDeleted,
      })
        .then((data) => {
          this.props.refresh();
        })
        .catch((e) => {
          console.log(e);
        });
    }
  }

  onShowDeleteModal() {
    if (!this.props.hasPermission) this.props.showPaidPlanModal();
    else {
      this.setState({
        showDeleteModal: true,
      });
    }
  }

  onCancel() {
    this.setState({
      showDeleteModal: false,
    });
  }

  onCloneTheme(theme) {
    if (!this.props.hasPermission) this.props.showPaidPlanModal();
    else {
      postTeamChartDuplicateUsingTeamidAndChartid(this.props.team.id, this.props.theme.id, {
        is_theme: true,
      })
        .then((data) => {
          this.props.refresh();
        })
        .catch((e) => {
          console.log(e);
        });
    }
  }

  render() {
    const { theme, team, divisions, isDeleted, isDefaultTheme, update, refresh } = this.props;
    return (
      <Card
        title={theme.name}
        href={({ ...ps }) => (
          <Link {...ps} onClick={this.props.checkHasPermission} to={this.props.theme.href}>
            {ps.children}
          </Link>
        )}
        thumbnail={theme.thumbnail_url}
      >
        {theme && (
          <ThemeModal
            ref={this.themeModal}
            theme={theme}
            team={team}
            divisions={divisions}
            update={update}
            refreshThemes={refresh}
            snackBar={snackBar}
          />
        )}

        <Modal
          className="hc-modal-content"
          appElement={document.querySelector('.page-container')}
          overlayClassName="hc-modal-overlay"
          isOpen={this.state.showDeleteModal}
          onRequestClose={this.onCancel}
          contentLabel="Delete"
        >
          <p>Are you sure you want to {isDeleted ? 'recover' : 'delete'} this theme?</p>
          <Button buttonClass="btn-primary" buttonText="Yes" onClick={this.onClick} />
          <Button buttonText="Cancel" buttonClass="btn-secondary" onClick={this.onCancel} />
        </Modal>

        <div>
          <div className="flex justify-between mt-4">
            <div className="space-x-6">
              {!isDefaultTheme && <Icon className="text-lg fa fa-cog" title="Settings" onClick={this.showModal} />}
              {!isDefaultTheme && (
                <Icon className="text-lg fa fa-clone" title="Duplicate" onClick={this.onCloneTheme} />
              )}
            </div>
            <div className="space-x-6">
              {!isDefaultTheme && (
                <Icon
                  title={isDeleted ? 'Recover' : 'Delete'}
                  className={`text-lg fa fa${isDeleted ? '-undo' : '-trash'}`}
                  onClick={this.onShowDeleteModal}
                />
              )}
            </div>
          </div>
        </div>
      </Card>
    );
  }
}

Theme.propTypes = {
  theme: PropTypes.object.isRequired,
  refresh: PropTypes.func,
  team: PropTypes.object,
  isDefaultTheme: PropTypes.bool,
  update: PropTypes.func,
  isDeleted: PropTypes.bool,
  hasPermission: PropTypes.bool,
  showPaidPlanModal: PropTypes.func,
};

export default Theme;
